export default {"src":"/accounts/_next/static/media/Algorand_logo.e61becb2.svg","height":650,"width":1500,"blurWidth":0,"blurHeight":0};